module.exports = __webpack_public_path__ + "img/12-01-1.b88fd499.svg";